import clsx from "clsx";

import useTranslation from "hooks/useTranslation";
import EditIcon from "assets/icons/iconComponents/Edit";
import TrashIcon from "assets/icons/iconComponents/Trash";
import confirmIcon from "assets/icons/confirmIcon.svg";
import rejectIcon from "assets/icons/rejectIcon.svg";
import styles from "./styles.module.scss";

function Pretext({
  item,
  index,
  searchingPretext,
  editingPretext,
  handleChangeInput,
  handleEditPretext,
  handleResetState,
  handleSelectMessage,
  handleEditPretextInput,
  setPretextsContent,
  setDeletingPretext,
  agentInfo,
}) {
  const { getTranslation } = useTranslation("CHAT");
  const { t } = getTranslation();

  const isPublic = !!item.publicId;

  const showItem =
    !searchingPretext ||
    item.q.includes(searchingPretext) ||
    item.a.includes(searchingPretext);

  const isItemTitleOnEdit =
    editingPretext.id === item.id && editingPretext.field === "title";

  const isDescriptionOnEdit =
    editingPretext.id === item.id && editingPretext.field === "description";

  /**
   * if message is not public then it belongs to the operator and operator can edit it
   * if it is public, then it's ownerId should be equal to the operator to be able for edit/delete it
   */
  const isActionPermitted = !isPublic || item.owner === agentInfo.id;

  const dataTooltipAttr = !isActionPermitted
    ? {
        "data-tool-tip-top": t("EDIT_NOT_PERMIT"),
      }
    : {};

  const handleRemovePretextClick = () => {
    if (!isActionPermitted) return;

    setPretextsContent("removePretext");
    setDeletingPretext(item);
  };

  const handleEditTitleClick = () => {
    if (!isActionPermitted) return;

    handleEditPretextInput(item, "title");
  };

  const handleEditPretextClick = () => {
    if (!isActionPermitted) return;

    handleEditPretextInput(item, "description");
  };

  return (
    showItem && (
      <div
        key={index}
        className={clsx([
          "conv__body__footer__cannedmsg_box__body__inner__row flex flex-ai-s",
          styles.row,
        ])}
      >
        {isItemTitleOnEdit ? (
          <div className="flex flex-ai-c">
            <input
              className="conv__body__footer__cannedmsg_box__body__inner__row__title_input"
              type="text"
              value={editingPretext.title}
              defaultValue={editingPretext.title}
              onChange={(e) => handleChangeInput(e.target.value, "title")}
            />
            <div className="flex flex-ai-c conv__body__footer__cannedmsg_box__body__inner__row__title_edit_actions">
              <span
                onClick={handleEditPretext}
                className="confirm_edit"
                role="button"
              >
                <img alt="confirm_icon" src={confirmIcon} />
              </span>

              <span
                onClick={handleResetState}
                className="reject_edit"
                role="button"
              >
                <img alt="reject_icon" src={rejectIcon} />
              </span>
            </div>
          </div>
        ) : (
          // title
          <div className="flex felx-ai-c conv__body__footer__cannedmsg_box__body__inner__row__title flex-noflex">
            <span onClick={handleSelectMessage(item.a)}>{item.q}</span>
            {isPublic && (
              <span className="conv__body__footer__cannedmsg_box__body__inner__row__title__public_badge flex flex-jc-c flex-ai-c">
                {t("PUBLIC")}
              </span>
            )}

            <span
              onClick={handleEditTitleClick}
              className={clsx([
                "flex conv__body__footer__cannedmsg_box__body__inner__row__edit",
                styles.action_btn,
              ])}
              role="button"
              data-disabled={!isActionPermitted}
              {...dataTooltipAttr}
            >
              <EditIcon color="#212121" />
            </span>
          </div>
        )}
        {isDescriptionOnEdit ? (
          <div className="flex flex-ai-e conv__body__footer__cannedmsg_box__body__inner__row__textArea_container">
            <textarea
              className="conv__body__footer__cannedmsg_box__body__inner__row__textArea"
              value={editingPretext.description}
              defaultValue={editingPretext.description}
              onChange={(e) => handleChangeInput(e.target.value, "description")}
            />
            <div className="flex flex-ai-c">
              <span
                onClick={handleEditPretext}
                className="confirm_edit"
                role="button"
              >
                <img alt="confirm_icon" src={confirmIcon} />
              </span>
              <span
                role="button"
                onClick={() => handleResetState()}
                className="reject_edit"
              >
                <img alt="reject_icon" src={rejectIcon} />
              </span>
            </div>
          </div>
        ) : (
          <div className="flex flex-jc-sb conv__body__footer__cannedmsg_box__body__inner__row__description">
            <p
              onClick={handleSelectMessage(item.a)}
              className="conv__body__footer__cannedmsg_box__body__inner__row__description__text"
            >
              {item.a}
            </p>
            <div className="flex flex-ai-c conv__body__footer__cannedmsg_box__body__inner__row__actions">
              <span
                onClick={handleEditPretextClick}
                className={clsx(
                  "flex conv__body__footer__cannedmsg_box__body__inner__row__actions_edit",
                  styles.action_btn
                )}
                role="button"
                data-disabled={!isActionPermitted}
                data-tool-tip-right
                {...dataTooltipAttr}
              >
                <EditIcon color="#fff" />
              </span>

              <span
                onClick={handleRemovePretextClick}
                className={clsx([
                  "flex conv__body__footer__cannedmsg_box__body__inner__row__actions_delete",
                  styles.action_btn,
                ])}
                role="button"
                data-tool-tip-right
                data-disabled={!isActionPermitted}
                {...dataTooltipAttr}
                data-type="content"
              >
                <TrashIcon color="#fff" />
              </span>
            </div>
          </div>
        )}
      </div>
    )
  );
}

export default Pretext;
